// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__14Nnl","footer_link":"Footer_footer_link__3F1lJ"};